import type { ReactNode } from 'react'
import styles from './highlight.module.css'

/**
 * Lifts the phrases worth reading twice out of a muted paragraph.
 *
 * The reference site sets its statement in grey with the substance — the
 * role, the years, the reach — picked out in white, which is what makes a
 * long sentence scannable rather than a wall to skip.
 *
 * The phrases come from the content rather than being written into the
 * markup, so editing a bio in the admin panel cannot leave the emphasis
 * pointing at words that are no longer there: a term that is not present is
 * simply not highlighted.
 */
export const highlight = (text: string, ...terms: string[]): ReactNode => {
  const found = terms.filter((term) => term && text.includes(term))
  if (found.length === 0) return text

  // Longest first, so "Kris David Steeve Ella" wins over "Kris".
  const pattern = new RegExp(
    `(${found
      .sort((a, b) => b.length - a.length)
      .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      .join('|')})`,
  )

  return text.split(pattern).map((part, index) =>
    found.includes(part) ? (
      <strong key={index} className={styles.lift}>
        {part}
      </strong>
    ) : (
      part
    ),
  )
}
